<div class="flex flex-col">
  <mat-label>
    {{ label | translate }}
    <span *ngIf="isRequired">*</span>
  </mat-label>
  <mat-form-field class="w-full">
    <mat-select
      [multiple]="multiple"
      [value]="value"
      (selectionChange)="onSelectionChange($event.value)"
      [disabled]="isDisabled"
      [placeholder]="placeholder | translate">
      <div *ngIf="hasSelectAll" class="select-deselect" (click)="$event.stopPropagation(); toggleSelectAll()">
        <app-icon [ngStyle]="{cursor:'pointer'}" size="md" [iconName]="selectedAll ? 'close' : 'check'"></app-icon>
        <span class="ml-1">{{ (selectedAll ? 'global.deselectAll' : 'global.selectAll') | translate }}</span>
      </div>
      <mat-divider></mat-divider>

      <mat-option *ngIf="hasDeletedDisabledDataToggle" [value]="-1" class="font-bold">
        {{ includeDeletedDataLabel | translate }}
      </mat-option>

      <mat-option *ngFor="let option of options" [value]="option.id">
        {{ option.name | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
